// extracted by mini-css-extract-plugin
module.exports = {"innerLayout":"styles_innerLayout__euWVw","innerLeft":"styles_innerLeft___rpoE","metricNumber":"styles_metricNumber__54sKz","metricCaption":"styles_metricCaption__C8gGb"};